<template>
    <div class="paddingtopbottom">
        <van-nav-bar :title="title"
                     :left-arrow="!uniqueId"
                     fixed
                     :right-text="title==='搜索药品'?'新增药品':''"
                     @click-left="onCompelete()"
                     @click-right="toNewMedicine" />
        <div :class="['search-box',(messageShow||cartShow)?'z-index':'']">
            <form @submit.prevent="formSubmit"
                  action="javascript:return true">
                <van-search id="gain"
                            v-model="searchVal"
                            placeholder="请输入药品首拼或关键字搜索"
                            shape="round"
                            type="search"
                            class="search-input"
                            @keydown="handleKeydown($event)"
                            background="#01B956"
                            @input="fetchData" />
            </form>
            <span class="search-btn2"
                  @click="handClickLabel(searchVal,null,null)">搜索</span>
        </div>
        <!--快速搜索-->
        <div v-show="list.length>0&&!isKeydown"
             class="search-main">
            <ul class="search-list">
                <li v-for="(item, index) in list"
                    :key="index"
                    @click="handClickLabel(item,index,'secSearch')"
                    v-html="onReplaceFont(item, searchVal.split(' ')[0])">
                </li>
                <li v-show="list.length === 0"
                    class="noli" />
            </ul>
        </div>
        <!--搜索结果列表-->
        <div class="nodata-wrap"
             v-show="searchVal&&!loading&&list.length===0&&listData.length===0">
            <img src="@/icons/nodata.png"
                 alt />
            <p>暂无搜索结果</p>
        </div>
        <div class="search-end"
             v-show="listData.length>0">
            <ul>
                <li v-for="(item, index) in listData"
                    :key="index">
                    <div class="search-wen">
                        <p style="margin-top: 0;">
                            <span v-show="parseInt(item.prescriptionYn) === 1">Rx</span>
                            {{ item.commonName }}
                        </p>
                        <!--            <p>{{ item.attributeSpecification }}</p>-->
                    </div>
                    <div class="search-label">
                        <!-- <div class="search-label-nums" v-if="item.quantity>0"> -->
                        <div class="search-label-nums"
                             v-if="item.show">
                            <van-stepper v-model="item.quantity"
                                         min="0"
                                         input-width="50"
                                         max="999"
                                         @plus="updateData(item, 'plus')"
                                         @minus="updateData(item, 'minus')"
                                         @blur="onBlur(item, 'change')" />
                            <div>g</div>
                        </div>
                        <span :disabled="!!uniqueId"
                              @click="!uniqueId && addMessage(item,index)"
                              v-else>
                            <van-icon name="plus" />
                        </span>
                    </div>
                </li>
            </ul>
        </div>
        <!--    &lt;!&ndash;修改商品&ndash;&gt;-->
        <!--    <shoppingMessageModify-->
        <!--      :edit-cart-index="editCartIndex"-->
        <!--      :message-show-modify="messageShowModify"-->
        <!--      :usedrug-data="usedrugData"-->
        <!--      :unit-data="unitData"-->
        <!--      :method-data="methodData"-->
        <!--      :dosage-data="dosageData"-->
        <!--      @closemessagemodifyval="closemessagemodifyval"-->
        <!--      @modifyGoods="modifyGoods"-->
        <!--    />-->
        <!--购物车-->
        <shoppingCart :cart-list="cartList"
                      :cart-showt="cartShow"
                      @closeCart="closeCart"
                      @deleteCart="deleteCart"
                      @deleteListData="deleteListData"
                      @editCart="editCart"
                      @updateData="updateData" />
        <!--底部-->
        <div class="footerbut footerbut2">
            <van-button round
                        block
                        type="danger"
                        :color="CartNum > 0 && !submitDisabled ? '#01B956' : '#C8C8C8'"
                        :disabled="CartNum > 0 ? submitDisabled : true"
                        text="确定"
                        @click="onCompelete" />
            <div :class="CartNum > 99 ? 'cart2' : 'cart'"
                 @click="!uniqueId && clickCart()">
                药品列表
                <span v-if="CartNum > 0">{{ CartNum > 99 ? "99..." : CartNum }}</span>
            </div>
        </div>
        <NewMedicineCn v-if="showAddCn"
                       @addMedicine="addMedicine"
                       @close="closeNewMedicine" />
        <loadingComponent :is-show="isShowLoading" />
    </div>
</template>
<script>
import loadingComponent from '@/components/Loading'
import {
    queryMedicineList2,
    drugsList2,
} from '@/api/index';
import NewMedicineCn from '@/components/chinese-medicine/newMedicineCn.vue'
import shoppingCart from "@/components/chinese-medicine/shopping-cart.vue";
import { getCookie } from '@/utils/auth'
// 节流函数
const delay = (function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();
export default {
    components: {
        loadingComponent,
        shoppingCart,
        NewMedicineCn
    },
    props: {
        callback: Function, // 完成回调
        type: Number, // 问诊类型
        channel: String // 保险渠道
    },
    props: {
        medicineArrCn: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data () {
        return {
            title: '搜索药品',
            showAddCn: false,
            isKeydown: false,
            submitDisabled: false, // 提交处方按钮,默认flase按钮可点
            isShowLoading: false,
            listData: [],
            cartShow: false, // 判断购物车显示隐藏
            messageShow: false, // 判断商品显示隐藏
            messageShowModify: false, // 判断商品修改显示隐藏
            searchVal: "", // 搜索值
            list: [],
            newListData: {},
            cartList: this.medicineArrCn,
            editCartIndex: 0,
            usedrugData: [], // 用药频率
            unitData: [], // 选择单位
            methodData: [], // 用药方法
            dosageData: [], // 用量
            uniqueId: "", // 数字签章的
            finishedText: "",
            pageNum: 1,
            pageSize: 30,
            loading: false,
            finished: false,
            addIconShow: true, // 药品加号显示
        };
    },
    computed: {
        CartNum () {
            return this.cartList.length;
        },
        ruleTitle () {
            let titleString = this.item.name;
            if (!titleString) {
                return "";
            }
            if (this.searchVal && this.searchVal.length > 0) {
                // 匹配关键字正则
                const replaceReg = new RegExp(this.searchVal, "g");
                // 高亮替换v-html值
                const replaceString =
                    '<span class="search-text">' + this.searchVal + "</span>";
                // 开始替换
                titleString = titleString.replace(replaceReg, replaceString);
            }
            return titleString;
        },

    },
    watch: {

        uniqueId (id) {
            !!id &&
                setTimeout(() => {
                    window.location.href = "protocol://action/prohibit_goback";
                }, 100);
        },
        searchVal (val) {
            delay(() => { }, 300);
        },
        'medicineArrCn': function (val) {
            this.cartList = val
        },
        deep: true,
        immediate: true

    },
    created () {
        // 提交处方失败
        window.failSubmitRX = () => {
            this.submitDisabled = false;
            this.isShowLoading = false;
        };
        // this.cartList = JSON.parse(localStorage.getItem("shoppingCartList")) || [];
    },
    mounted () {
        this.$nextTick(() => {
            document.getElementById("gain").focus();
        });
    },
    beforeDestroy () {
        if (this.uniqueId) {
            // 清除购物车
            // localStorage.removeItem("diacrisisText");
            // localStorage.removeItem("diseaseCooes");
            // localStorage.removeItem("tagNames");
            // localStorage.removeItem("shoppingCartList");
            // this.cartList.splice(0);
        }
    },
    methods: {
        deleteMedicineFromFather (pref, flag = true) {
            const index = this.listData.findIndex(item => {
                return item.pref == pref
            })
            if (index > -1) {
                this.listData[index].quantity = 0
                this.listData[index].show = false
            }
            if (flag) {
                this.$emit('callback', this.cartList)
            }
        },
        closeNewMedicine () {
            this.showAddCn = false
            this.title = '搜索药品'
        },
        toNewMedicine () {
            this.title = '新增药品'
            this.showAddCn = true
        },
        /**
        * @description:处理键盘事件
        * @param: {Object} ev 键盘事件对象
        * @return: this.handClickLabel(this.searchVal,null,null)
       */
        handleKeydown (ev) {
            if (ev.keyCode === 13) {
                this.isKeydown = true
                this.handClickLabel(this.searchVal, null, null)
            }
        },
        formSubmit () {
            return false
        },
        /**
         * @description: 替换搜索关键字为红字
         * @param {string, string} oraignString - 要匹配的字符串， searchVal - 匹配关键字
         * @return: string 返回匹配后的完整的字符串
         */
        onReplaceFont (oriStr, searchVal, type) {
            // 匹配姓名，没有大小写问题
            if (type === 'username') {
                let reg = new RegExp(searchVal, 'g')
                let replaceHtml = '<font style="color:#EF4D4D">' + searchVal + '</font>'
                return oriStr.replace(reg, replaceHtml)
            }
            const firstStr =
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) !== -1
                    ? oriStr.slice(
                        0,
                        oriStr.toLowerCase().indexOf(searchVal.toLowerCase())
                    )
                    : ''
            const secondStr = `<span
        style="color:#EF4D4D"
      >
        ${oriStr.slice(
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()),
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) +
                searchVal.length
            )}
      </span>`
            const thirdStr =
                oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) !== -1
                    ? oriStr.substr(
                        oriStr.toLowerCase().indexOf(searchVal.toLowerCase()) +
                        searchVal.length
                    )
                    : oriStr
            return firstStr + secondStr + thirdStr
        },
        fetchData (val) {
            this.isShowLoading = true;
            this.pageNum = 1;
            this.list = [];
            this.listData = [];
            this.finishedText = "";
            this.finished = false;
            this.isKeydown = false
            this.getTypeDate(val);
        },
        // 获取搜索数据
        async getTypeDate (val) {
            this.loading = true;
            if (val === "") {
                this.isShowLoading = false;
                this.listData = [];
                return;
            }
            const params = {
                productName: val,
                organSign: getCookie('native_organSign'),
                productType: 1,
                specifications: ''
            };
            try {
                let res = await queryMedicineList2(params)
                if (res.data.code === 0) {
                    this.loading = false;
                    this.isShowLoading = false;
                    const newslist = (res.data && res.data.result) || [];
                    if (!this.searchVal) return false;
                    this.list = newslist;
                    // 如果当前页数 = 总页数，则已经没有数据
                    if (!res.data.data) {
                        this.finished = true;
                        this.finishedText = "没有更多了";
                    }
                    window.webSdk.track('searchMedicineCn', { searchVal: this.searchVal })
                }
            }
            catch (err) {
                this.isShowLoading = false;
                this.loading = false;
            }
        },
          //海典自动填充
        haiDianAutoWriteFun(item){
            this.searchVal = item.commonName;
            this.handClickLabel( this.searchVal, null, 'secSearch')
        },
        // 获取搜索结果数据
        async handClickLabel (name, index, type) {
            this.isShowLoading = true
            this.loading = true;
            let params_name = name
            let searchValArr = this.searchVal.split(' ')
            if (searchValArr.length > 1 && type === 'secSearch') {
                searchValArr[0] = name
                params_name = searchValArr.join(' ')
            }
            // const params = {
            //   productName: params_name,
            //   organSign: getCookie('native_organSign'),
            //   thirdChannel: this.channel
            // }
            const params2 = {
                productName: params_name,
                organSign: getCookie('native_organSign'),
                productType: 1
            }
            let res;
            res = await drugsList2(params2);
            this.list = [];
            this.listData = res.data.result.map((item, index) => {
                this.$set(item, 'quantity', 0)
                this.$set(item, 'show', false)
                return item
            })
            this.cartList.forEach(item => {
                let status = this.listData.findIndex(value => value.pref === item.pref)
                if (status > -1) {
                    this.listData[status].quantity = item.quantity
                    this.listData[status].show = true
                }
            })
            if (searchValArr.length > 1 && type === 'secSearch') {
                searchValArr[0] = name
                this.searchVal = searchValArr.join(' ')
            } else {
                this.searchVal = name
            }
            window.webSdk.track('searchMedicineCn', { searchVal: this.searchVal })
            this.loading = false;
            this.isShowLoading = false
        },
        // 删除购物车里商品
        deleteCart (item) {
            for (let i = 0; i < this.cartList.length; i++) {
                if (this.cartList[i].pref === item.pref) {
                    this.cartList.splice(i, 1)
                    item.quantity = 0
                    item.show = false
                }
            }
        },
        deleteListData (item) {
            for (let i = 0; i < this.listData.length; i++) {
                if (this.listData[i].pref === item.pref) {
                    this.listData[i].quantity = 0
                    this.listData[i].show = false
                }
            }
        },
        // 修改购物车里的商品
        editCart (data) {
            this.editCartIndex = data;
            this.messageShowModify = true;
        },
        onBlur (item) {
            this.$nextTick(() => {
                if (item.quantity > 0) {
                    item.show = true
                    let status = this.cartList.findIndex(value => value.pref === item.pref)
                    if (status > -1) {
                        this.updateCarList(status, item)
                    }
                } else {
                    item.show = false
                    this.deleteCart(item)
                }
            })

        },
        updateData (item, type) {
            this.$nextTick(() => {
                // if (type === 'plus') {
                //   item.quantity++
                // } else if (type === 'minus') {
                //   item.quantity--
                // }
                let status = this.cartList.findIndex(value => value.pref === item.pref)
                if (status > -1) {
                    if (type === 'minus' || type === 'plus') {
                        if (item.quantity <= 0) {
                            this.deleteCart(item)
                            this.deleteListData(item)
                        } else {
                            this.updateCarList(status, item)
                        }
                    } else if (type === 'change') {
                        // item.quantity <= 0 ? this.deleteCart(item) :  this.updateCarList(status, item)
                        if (item.quantity <= 0) {
                            this.deleteCart(item)
                            this.deleteListData(item)
                        } else {
                            this.updateCarList(status, item)
                        }
                    }
                }
            })

        },

        // 点击购物车
        clickCart () {
            if (this.CartNum !== 0) {
                this.cartShow = true;
            }
        },
        closeCart () {
            this.cartShow = false;
        },
        // 点击商品添加
        addMessage (item, index) {
            if (
                this.cartList.length > 0 &&
                this.cartList.some(data => data.productPref === item.pref)
            ) {
                this.$toast("购物车已存在该产品");
                return;
            }
            if (this.cartList.length === 33) {
                this.$toast("药品种类已达上限");
                return;
            }
            item.show = true
            item.quantity = 10
            this.addIconShow = false
            this.cartList.push(item);
        },
        addMedicine (data) {
            if (this.medicineArr.length > 4) {
                this.$toast({
                    message: '最多添加5种药品',
                    duration: 2000
                })
                this.showAdd = false
                return false
            }
            data && this.medicineArr.push(data)
            this.showAdd = false
            window.webSdk.track('newMedicineCn', {})
        },

        addMedicine (data) {
            if (this.cartList.length > 32) {
                this.$toast({
                    message: '最多添加5种药品',
                    duration: 2000
                })
                this.showAdd = false
                return false
            }
            this.cartList.push(data)
            this.showAddCn = false
            this.title = '搜索药品'
        },
        // 完成病情描述并返回
        onCompelete () {
            if (this.showAddCn) {
                this.showAddCn = false
                this.title = '搜索药品'
            } else {
                this.list = []
                this.listData = []
                this.searchVal = ''
                this.$emit('callback', this.cartList)
            }
        },
        // 更新购物车data、localStorage
        updateCarList (index, data) {
            this.cartList[index].quantity = data.quantity
        },
        // 更新搜索list数量
        updateListData (data) {
            let index = this.listData.findIndex(value => value.pref === data.pref)
            if (index > -1) {
                this.listData[index].quantity = data.quantity
            }
        }
    }
};
</script>
<style scoped lang="scss">
@import '../../styles/goods.css';
[disabled] {
    background: rgb(200, 200, 200);
    border-color: rgb(200, 200, 200);
}
.paddingtopbottom {
    padding: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9;
    left: 0;
    top: 0;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    z-index: 1000;
    .van-nav-bar {
        z-index: 99999 !important;
    }
    .van-search {
        background: #fff !important;
        .van-search__content {
            background: #f7f8fa;
        }
    }
    .search-label {
        span {
            width: 22px;
            height: 22px;
            padding: 0;
            background: #01b956;
            i {
                line-height: 22px;
            }
        }
        .search-label-nums {
            display: flex;
            font-size: 14px;
            .van-stepper {
                border: 1px solid #efeff5;
                border-radius: 26px;
                padding: 2px 5px;
            }
            > div {
                margin-left: 5px;
            }
            /deep/ .van-stepper__minus,
            /deep/ .van-stepper__plus,
            /deep/ .van-stepper__input {
                width: 20px;
                height: 20px;
                background: transparent;
            }
            /deep/ .van-stepper__input {
                width: 38px;
            }
        }
        align-items: center;
    }
    .footerbut {
        background: #fff;
    }
}

.search-box {
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 1px;
    // top: -32px;
    background: white;
    /deep/ .van-search__content {
        padding-right: 55px;
    }
    form {
        width: 100%;
    }
    .search-input {
        width: 100%;
    }
    .width80 {
        width: 80%;
    }
    .search-btn2 {
        height: 100%;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #01b956;
        display: block;
        line-height: 34px;
        text-align: center;
        position: absolute;
        right: 15px;
        background: #d9ebff;
        border-radius: 17px;
        width: 58px;
        height: 34px;
        background: rgba(1, 185, 86, 0.05) !important;
    }
    .filter {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 65px;
        img {
            width: 14px;
            height: 16px;
        }
    }
    .blue {
        color: #018bff;
    }
}

.search-main {
    background: #f7f7f7;
    .search-list {
        padding: 0 30px;
        padding-top: 20px;
        //padding-top:40px;
        height: calc(100vh - 215px);
        overflow-y: auto;
        background: white;
    }
}

.search-end {
    padding-top: 90px;
    height: calc(100% - 100px);
    position: relative;
    ul {
        margin-top: 10px;
        padding-bottom: 80px;
        li {
            padding-left: 5px;
            padding-right: 5px;
            height: 30px;
            .search-wen {
                line-height: 30px;
                width: 50%;
                p {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }
}
.van-nav-bar {
    z-index: 99999 !important;
}
.nodata-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
    img {
        width: 160px;
        height: 130px;
    }
    p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        //margin-top: 5px;
    }
}
.z-index {
    z-index: 1;
}
</style>

<style lang="scss" scoped>
/*底部按钮*/
.footerbut {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 15px 30px 30px;
    box-sizing: border-box;
    background-color: #f7f7f7;
}
.footerbut2 {
    padding: 15px 15px 15px 30px;
}
.van-button__text {
    font-size: 18px;
}
.footerbut2 .van-button--block {
    width: 254px;
    float: right;
}
.footerbut2 .cart,
.footerbut2 .cart2 {
    width: 48px;
    padding-top: 27px;
    font-size: 12px;
    color: #666;
    background: url(../../icons/medicineList.png) no-repeat center 0;
    background-size: 24px 24px;
    position: relative;
}
.footerbut2 .cart span {
    width: 15px;
    height: 15px;
    background: rgba(239, 77, 77, 1);
    border: 1px solid rgba(239, 77, 77, 1);
    font-size: 12px;
    color: #fff;
    display: block;
    position: absolute;
    top: -5px;
    right: 5px;
    text-align: center;
    border-radius: 100%;
    line-height: 16px;
}
.footerbut2 .cart2 span {
    height: 16px;
    width: auto;
    padding: 0 5px;
    background: rgba(239, 77, 77, 1);
    border: 1px solid rgba(239, 77, 77, 1);
    font-size: 12px;
    color: #fff;
    display: block;
    position: absolute;
    top: -8px;
    right: -10px;
    text-align: center;
    border-radius: 30px;
    line-height: 16px;
}

/*搜索*/
.search-box {
    padding: 0 15px;
    position: fixed;
    top: 44px;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    z-index: 1005;
}
.van-search {
    padding: 0;
    margin: 0;
}
.van-search__content {
    background: #fff;
    padding-left: 10px;
}
.van-search__action {
    color: #5670f0;
}
.search-main {
    position: fixed;
    top: 82px;
    left: 0;
    width: 100%;
    background: #fff;
    // height: 100%;
    // padding-bottom:80px;
    box-sizing: border-box;
    overflow: auto;
}
.search-list li {
    border-bottom: 1px solid #ededed;
    padding: 9px 0;
    font-size: 15px;
    color: #333;
}
.search-list li:nth-last-child(2) {
    border: 0;
}
.van-dialog__confirm,
.van-dialog__confirm:active {
    color: rgb(86, 112, 240);
}
.van-nav-bar__text {
    color: rgb(86, 112, 240);
}
.van-search /deep/ .van-icon-search {
    background: url(../../icons/search.png) no-repeat 0 center;
    background-size: 17px 16px;
}
.van-search /deep/ .van-icon-search:before {
    content: '';
}
.van-search /deep/ .van-field__left-icon {
    margin-right: 10px;
}
</style>
